/**
 * @file
 * Tooltip script.
 */

(function tooltipScript($, Drupal) {
  'use strict';

  Drupal.behaviors.tooltip = {
    attach: function tooltipAttach(context) {
      // Get all the tooltip buttons
      var tooltips = document.querySelectorAll('[data-tooltip-content]');

      // Iterate over them
      Array.prototype.forEach.call(tooltips, function (tooltip) {
        // Get the message from the data-content element
        var message = tooltip.getAttribute('data-tooltip-content');

        // Get the live region element
        var liveRegion = tooltip.nextElementSibling;

        // Toggle the message
        var showTooltipBubble = function () {
          liveRegion.innerHTML = '';
          window.setTimeout(function () {
            liveRegion.innerHTML = '<span class="tooltip__bubble">' + message + '</span>';
          }, 100);
        };
        tooltip.addEventListener('click', showTooltipBubble);
        tooltip.addEventListener('focus', showTooltipBubble);

        // Close on outside click
        document.addEventListener('click', function (e) {
          if (tooltip !== e.target) {
            liveRegion.innerHTML = '';
          }
        });

        // Remove tooltip on ESC
        tooltip.addEventListener('keydown', function (e) {
          if ((e.keyCode || e.which) === 27) {
            liveRegion.innerHTML = '';
          }
        });

        // Remove on blur
        tooltip.addEventListener('blur', function (e) {
          liveRegion.innerHTML = '';
        });
      });
    }
  };
}(jQuery, Drupal));
